import styled from 'styled-components';

export const IconContainer = styled.span`
	display: inline-block;
	height: ${({ size }) => size}px;
	width: ${({ size }) => size}px;
`;

export const IconItemStyled = styled.svg`
	height: 100%;
	width: 100%;
`;
